import { Injectable } from '@angular/core';
import { CONFIG } from '../../shared/config';
import { HttpGeneralService } from '../../shared';

const operationPlaceSettingApiurl = CONFIG.baseUrls.operationPlaceSetting;

export interface inTransferBodies {

  serial?: number;
  nameAr: string;
  nameEn: string;
  address: string;
  feesRate: string;
  speciality: string;
  rowStatus?: number;
  Status?: number;
  discountValue?: number;
  percentOrValue?: number;
  cshDiscountsCode?: number;
  confirmedBy?: number;
  accountNo?: number;
}

export interface priComingFromExceptions {
  serial?: number;
  rowStatus?: number;
  Status?: number;
  serviceCode?: number;
  comingFrom?: number;
  increaseOrDecrease?: number;
  valueOrPercent?: number;
  value?: number;
}


export interface MedicalConSent {

  code?: number;
  nameAr: string;
  nameEn: string;
  rowStatus?: number;
  dataStatus?: number;
  patCode?: number;
  visitSerial?: number;

}



@Injectable({
  providedIn: 'root'
})
export class OperationPlaceSettingsService {

  constructor(private httpGeneralService: HttpGeneralService) { }

  addinTransferBodies(inTransferBodies: inTransferBodies[]) {
    return this.httpGeneralService.addCollection(inTransferBodies, operationPlaceSettingApiurl)
  }
  addPriComingFromExceptions(PriComingFromExceptions: any[]) {
    return this.httpGeneralService.addCollection(PriComingFromExceptions, `${operationPlaceSettingApiurl}/addPriComingFromExceptions`);
  }
  getPriComingFromExceptions(data: any) {
    return this.httpGeneralService.post(data, `${operationPlaceSettingApiurl}/getPriComingFromExceptions`);
  }

  // getinTransferBodies(serial: number) {
  //   return this.httpGeneralService.get(serial, operationPlaceSettingApiurl);
  // }

  getinTransferBodies(data: any) {
    return this.httpGeneralService.post(data, `${operationPlaceSettingApiurl}/getinTransferBodies`);
  }


  updateComingFrom(object: any) {
    return this.httpGeneralService.post(object, `${operationPlaceSettingApiurl}/updateComingFrom`);
  }
  deleteinTransferBodies(serial: number) {
    return this.httpGeneralService.delete(serial, operationPlaceSettingApiurl);
  }
  deletePriComingFromExceptions(serial: number) {
    return this.httpGeneralService.delete(serial, `${operationPlaceSettingApiurl}/deletePriComingFromExceptions`);
  }
  updateinTransferBodies(inTransferBodies: inTransferBodies) {
    return this.httpGeneralService.update(inTransferBodies.serial, inTransferBodies, operationPlaceSettingApiurl);
  }

  medicalConcentDoc(LoyalityMembership: MedicalConSent) {
    return this.httpGeneralService.add(LoyalityMembership, `${operationPlaceSettingApiurl}/medicalConcentDoc`);
  }

  getmedicalConcentDocLookup(inTransferBodies: MedicalConSent) {
    return this.httpGeneralService.add(inTransferBodies, `${operationPlaceSettingApiurl}/getMedicalConcentDocLookup`)

  }
}

